<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Normal ParaOverride-6">To Molly, who never, ever went away. </p>
<p class="Normal ParaOverride-5">I’m so thankful that Tanya is purely a product of my imagination. </p>
<p class="heading-3 ParaOverride-8"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// When_You_Went_Away-3.vue?27d93985